import { TOAuthSource } from '@/utils/oAuth';
import request from './request';

type LoginReq = {
  password: string;
  username: string;
  tokenTime?: number;
  type: string;
  sig: { data?: string; result?: string };
  from: string | 'Console';
  ts: number;
  source?: string;
  identifier?: string;
  product?: string;

  zgaReportId?: string;

  notThroughPortal?: boolean;

  /*
    风控信息
  */
  info?: string;
};

export type LoginResp = {
  lastLoginTime?: string;
  lastTeamUid?: string;
  redirectUrl?: string;
  sigCode?: string;
  token?: string;
  userUid?: string;
  forcePassword?: 'open';
  verificationMethods?: ('TOTP' | 'EMAIL')[];
};
type EmailValidationResp = {
  email: string;
  teamName: string;
  teamUid: string;
  uid: string;
  userStatus: string;
  username: string;
  validationType:
    | 'REGISTER'
    | 'FORGET_PASSWORD'
    | 'TEAM_INVITATION'
    | 'UPDATE_USERNAME';
  zgaReportId?: string;
};

/**
 * 用户注册
 */
export function register(data: any) {
  return request<any>({
    method: 'post',
    url: '/register',
    data,
  });
}

// export function registerByPardot(data: any) {
//   return new Promise<RequestRes<null>>((resolve) => {
//     const fd = new URLSearchParams();
//     Object.keys({ ...data, encoding: 'UTF-8' }).forEach((k) => {
//       if (!!data[k]) {
//         fd.append(k, data[k]);
//       }
//     });
//     window.pardotCallback = (res) => {
//       if (res?.result === 'success') {
//         resolve({
//           success: true,
//           msg: 'success',
//           data: null,
//           ret: -1,
//           code: '',
//         });
//       } else {
//         resolve({
//           success: false,
//           msg: 'fail',
//           data: null,
//           ret: -1,
//           code: '',
//         });
//       }
//     };
//     ajax({
//       method: 'post',
//       url: `https://go.zenlayer.com/l/879902/2021-01-13/2n762?${fd.toString()}`,
//       dataType: 'jsonp',
//       jsonpCallback: 'pardotCallback',
//     });
//   });
// }

/**
 * 用户注册-邮箱校验
 */
export function registerValidation<T>(data: string) {
  return request<T>({
    method: 'get',
    url: `/email/validationn/${data}`,
  });
}

/**
 * 用户注册-发送email
 */
export function registerEmailSend(data: string) {
  return request<any>({
    method: 'put',
    url: `/register/email/${data}`,
  });
}

/**
 * 用户注册-激活
 */
export function registerActivate(data: string) {
  return request<any>({
    method: 'put',
    url: `/register/activate/${data}`,
  });
}

/**
 * 修改用户名-确认
 */
export function updateUsernameConfirm(key: string) {
  return request({
    method: 'put',
    url: `/email/validation/${key}`,
  });
}

/**
 * 验证用户是否有资格加入team
 */
export function teamConfirInvitation<T>(data: string) {
  return request<T>({
    method: 'put',
    url: `/team/confirm_invitation/${data}`,
  });
}

/**
 * 用户登录
 */
export enum UserBelong {
  portal = 'PORAL',
  console = 'CONSOLE',
}
export function loginType(username: string, notThroughPortal?: boolean) {
  return request<UserBelong>({
    method: 'get',
    url: '/login',
    params: {
      username,
      notThroughPortal,
    },
  });
}
export function login(data: LoginReq) {
  return request<LoginResp>({
    method: 'post',
    url: '/login',
    data,
  });
}
export function tokenLogin(data: {
  token: string;
  sig: { data?: string; result?: string };
}) {
  return request<LoginResp>({
    method: 'put',
    url: '/login',
    data,
  });
}

/**
 * 用户登出
 */
export function logout() {
  return request<null>({
    method: 'post',
    url: '/logout',
  }).then((res) => {
    return res;
  });
}

export function emailValidation(id: string) {
  return request<EmailValidationResp>({
    method: 'get',
    url: `/email/validation/${id}`,
  });
}

// ------------以下是新的----------------
/**
 * 注册时候的邮箱验证
 */
interface EmailCodeParams {
  code: string;
  username: string;
}
export function putEmailCode(data: EmailCodeParams) {
  return request<null>({
    method: 'put',
    url: '/register/emailCode/verification',
    data,
  });
}

/**
 * 注册时候的重发邮箱
 */
export function putResendCaptcha(email: string) {
  return request<null>({
    method: 'put',
    url: `/register/emailCode/${email}`,
  });
}

/**
 * 完善信息
 */
interface RefineBillingInfoParams {
  companyAddress: string;
  companyName: string;
  companyType: string;
  phone: string;
  country: string;
  zipCode: string;
}
export function refineBillingInfo(data: RefineBillingInfoParams) {
  return request<null>({
    method: 'post',
    url: '/register/billing',
    data,
  });
}

// 注册时填account信息，触发发邮件
export interface RegisterAccountParams {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
}
export function registerAccount(data: RegisterAccountParams) {
  return request<{ uid: string }>({
    method: 'post',
    url: '/register/account',
    data,
  });
}

/**
 * 创建Team
 */
interface CreateTeamParams {
  companyAddress: string;
  companyName: string;
  companyType: string;
  phone: string;
  country: string;
  zipCode: string;
}
export function createTeam(data: CreateTeamParams) {
  return request<any>({
    method: 'post',
    url: '/teams',
    data,
  });
}

interface IOAuthUrlParams {
  redirectTo?: string;
  referralCode?: string;
  info: string;
}

export function getOAuthUrl(source: TOAuthSource, data: IOAuthUrlParams) {
  return request<string>({
    method: 'post',
    url: `/login/oauth/render/${source}`,
    data,
  });
}

interface Signup_OAuthParams {
  token: string;
  firstName: string;
  lastName: string;
  username: string;
  info: string;
}
export function postSignup_OAuth(data: Signup_OAuthParams) {
  return request<LoginResp>({
    method: 'post',
    url: `/login/oauth/register`,
    data,
  });
}

interface OneTapLoginParams extends IOAuthUrlParams {
  /** Google 签名的 ID Token(JWT),由 One Tap 的 callback 交给前端 */
  credential: string;
}
/**
 * Google One Tap 登录。
 *
 * 后端做与现有 OAuth 回调完全相同的判定(已注册直接登录 / 未注册跳注册页),
 * 只是把原本写进 302 Location 头的地址改为放在响应体里返回,由前端整页跳过去。
 */
export function postOneTapLogin(data: OneTapLoginParams) {
  return request<{ redirectUrl: string }>({
    method: 'post',
    url: '/login/oauth/onetap/google',
    data,
  });
}
